(()=>{
 if(window.vendifoxCompareV9)return;window.vendifoxCompareV9=true;
 const specs={
  "snacks-und-drinks": {
    "dimensions": "1940 × 1290 × 870 mm",
    "display": "22 Zoll Touchscreen",
    "capacity": "60 Slots · bis zu 800 Produkte",
    "temperature": "4 bis 25 °C",
    "outdoor": "Outdoor-Konfiguration optional",
    "payment": "Nayax / Senvend optional",
    "accessories": true,
    "source_section": "custom-product-description-vision.liquid"
  },
  "t4s004": {
    "dimensions": "1940 × 1290 × 870 mm",
    "display": "Klassische Bedienung",
    "capacity": "60 Slots · bis zu 800 Produkte",
    "temperature": "4 bis 25 °C",
    "outdoor": "Outdoor-Konfiguration optional",
    "payment": "Nayax / Senvend optional",
    "accessories": true,
    "source_section": "custom-product-description-classic.liquid"
  },
  "t4s003": {
    "dimensions": "1940 × 1600 × 870 mm",
    "display": "22 Zoll Touchscreen · Lift",
    "capacity": "64 Slots · bis zu 560 Produkte",
    "temperature": "4 bis 25 °C",
    "outdoor": "Outdoor-Konfiguration optional",
    "payment": "Nayax / Senvend optional",
    "accessories": true,
    "source_section": "custom-product-description-nova.liquid"
  },
  "vendifox-slim": {
    "dimensions": "1940 × 732 × 790 mm (H × B × T)",
    "display": "5 Zoll LCD",
    "capacity": "36 Fächer · bis zu ca. 180 Getränke",
    "temperature": "2 bis 25 °C",
    "outdoor": "Outdoor-Konfiguration optional",
    "payment": "Nayax / Senvend optional",
    "accessories": true,
    "output": "Spiral / Conveyor / Pusher",
    "source_section": "custom-product-description-vendifox-slim.liquid"
  },
  "steam": {
    "dimensions": "1940 x 1290 x 870 mm",
    "display": "50 Zoll",
    "capacity": "48 Slots bis zu 432 verschiedene Produkte",
    "temperature": "Raumtemperatur",
    "source_section": "custom-product-description-vendifox-steam.liquid"
  },
  "t4s009": {
    "dimensions": "1940 x 1290 x 870 mm",
    "display": "22 Zoll Touch Display",
    "capacity": "36 Einzelfächer oder 18 Doppelfächer mit bis zu 260 Produkten",
    "temperature": "Einstellbar von 4°C bis 25°C",
    "output": "Liftsystem / Rollband",
    "source_section": "custom-product-description-lift-up.liquid"
  },
  "t4s008": {
    "source_section": "custom-product-description-lift-up-classic.liquid",
    "output": "Liftsystem / Rollband"
  },
  "t4s006": {
    "dimensions": "1940 x 2306 x 790 mm",
    "display": "22 Zoll Touchscreen",
    "capacity": "120 Slots, bis zu 1.600 Produkte",
    "temperature": "Einstellbar von 4°C bis 25°C",
    "source_section": "custom-product-description-infinity-vision.liquid"
  },
  "t4s005": {
    "dimensions": "1940 x 2306 x 790 mm",
    "capacity": "120 Slots, bis zu 1.600 Produkte",
    "temperature": "Einstellbar von 4 °C bis 25 °C",
    "source_section": "custom-product-description-infinity.liquid"
  },
  "vendifox-light": {
    "dimensions": "1.940 mm × 885 mm × 790 mm (H × B × T)",
    "display": "5\" LCD-Display serienmäßig",
    "capacity": "Bis zu ca. 240 Getränke",
    "temperature": "2 °C bis 25 °C, einstellbar",
    "output": "Spiral / Conveyor / Pusher",
    "source_section": "custom-product-description-vendifox-light.liquid"
  },
  "vendifox-cashless": {
    "dimensions": "1.940 mm × 882 mm × 790 mm (H × B × T)",
    "display": "5\" LCD-Display serienmäßig",
    "capacity": "Bis zu ca. 300 Getränke",
    "temperature": "2 °C bis 25 °C, einstellbar",
    "output": "Spiral / Conveyor / Pusher",
    "source_section": "custom-product-description-vendifox-cashless.liquid"
  },
  "vendifox-ramen-more": {
    "dimensions": "1.940 mm × 1.403 mm × 790 mm (H × B × T)",
    "display": "21,5\" Touchscreen",
    "capacity": "Bis zu ca. 300 Produkte",
    "output": "Spiral / Conveyor",
    "source_section": "custom-product-description-vendifox-ramen-more.liquid"
  },
  "vendifox-nova-ice-1": {
    "dimensions": "1.960 mm × 1.420 mm × 982 mm (H × B × T)",
    "display": "21,5\" Touchscreen",
    "capacity": "Ca. 270–500 Produkte",
    "temperature": "Bis -25 °C, einstellbar",
    "output": "Conveyor / Spiral mit Elevator-Tray-Lift",
    "source_section": "custom-product-description-Nova-ice.liquid"
  },
  "vendifox-nova-ice": {
    "dimensions": "1.960 mm × 1.375 mm × 875 mm (H × B × T)",
    "display": "21,5\" Touchscreen",
    "capacity": "Ca. 270–500 Produkte",
    "temperature": "Bis -25 °C, einstellbar",
    "output": "Conveyor / Spiral",
    "source_section": "custom-product-description-liftup-ice.liquid"
  },
  "vendifox-steam-ice": {
    "dimensions": "1.960 mm × 1.163 mm × 944 mm (H × B × T)",
    "display": "49\" Touchscreen mit Werbefunktion",
    "temperature": "Bis -25 °C, einstellbar",
    "output": "Conveyor / Spiral",
    "source_section": "custom-product-description-steam-ice.liquid"
  },
  "vendifox-ice-light": {
    "dimensions": "1.960 mm × 850 mm × 930 mm (H × B × T)",
    "display": "10\" Touchscreen",
    "capacity": "Ca. 150–330 Produkte",
    "output": "Conveyor / Spiral mit Liftsystem",
    "source_section": "custom-product-description-Vendifox-ice-light.liquid"
  },
  "brew": {
    "dimensions": "1940 x 790 x 735 mm",
    "capacity": "140–160 Tassen (mit optionalem Deckel)",
    "temperature": "92°C Brühtemperatur",
    "source_section": "custom-product-description-brew.liquid",
    "output": "Heißgetränkeausgabe"
  },
  "t4s009-1": {
    "source_section": "custom-product-description-bite-brew.liquid",
    "display": "16 Metalltasten / 22-Zoll-Display laut Beschreibung"
  },
  "t4s013": {
    "dimensions": "1940 x 1270 x 790 mm",
    "display": "20 Zoll Touch Screen",
    "capacity": "Bis zu 10 verschiedene Artikel (je nach Größe) ca. 150 Stück",
    "temperature": "Raumtemperatur",
    "source_section": "custom-product-description-vape.liquid"
  },
  "facherautomat-19er": {
    "source_section": "custom-product-description-fach19.liquid"
  },
  "facherautomat-27er": {
    "source_section": "custom-product-description-fach27.liquid"
  },
  "facherautomat-40er": {
    "source_section": "custom-product-description-fach40.liquid"
  },
  "facherautomat-64er": {
    "dimensions": "1940 mm Höhe × 1080 mm Breite × 320 mm Tiefe",
    "source_section": "custom-product-description-fach64.liquid"
  },
  "vendifox-smart-locker-cool": {
    "dimensions": "2.130 mm × 1.200 mm × 790 mm (H × B × T)",
    "temperature": "4 °C bis 25 °C, einstellbar",
    "source_section": "custom-product-description-smartlockcool.liquid"
  },
  "slave-modul": {
    "dimensions": "ca. 88,2 × 194 × 79 cm",
    "capacity": "6 Ebenen mit je 10 Slots",
    "temperature": "ca. 4 °C bis 25 °C",
    "source_section": "custom-product-description-slavemodul.liquid"
  },
  "vendifox-greifautomat-mit-trostpreis": {
    "dimensions": "85 × 200 × 80 cm",
    "source_section": "custom-product-description-clawHL.liquid"
  },
  "pink-date-scheren-automat": {
    "dimensions": "80 cm × 210 cm × 90 cm",
    "source_section": "custom-product-description-Pinkdate.liquid"
  },
  "vendifox-101-greifautomat": {
    "dimensions": "800 x 800 x 1945 mm",
    "source_section": "custom-product-description-Claw.liquid"
  }
},key='vendifox-model-comparison-v7',node=(tag,text)=>{const n=document.createElement(tag);if(text!=null)n.textContent=String(text);return n;};let selected=[],opener;
 try{const saved=JSON.parse(sessionStorage.getItem(key)||'[]');if(Array.isArray(saved))selected=saved.filter(m=>m&&typeof m.id==='string'&&typeof m.title==='string'&&typeof m.url==='string'&&/^(?:\/|https?:)/.test(m.url)).slice(0,3);}catch{}
 const info=card=>{const link=card.querySelector('.vf3-model-link'),title=card.querySelector('h3')?.textContent.trim();if(!link||!title)return null;const url=link.getAttribute('href'),handle=url?.split('/').pop().split('?')[0],known=specs[handle]||{},data=card.querySelector('.vf7-model-tools')?.dataset||{},model={...known,id:card.id||handle,title,url,image:card.querySelector('.vf3-model-img')?.currentSrc||card.querySelector('img')?.src||'',label:card.querySelector('.vf3-label')?.textContent.trim()||'Automat',description:card.querySelector('.vf3-model-copy>p')?.textContent.trim()||'',price:card.querySelector('.vf3-price')?.childNodes[0]?.textContent.trim()||'Preis im Produkt'};for(const k of ['dimensions','display','capacity','temperature','outdoor','payment'])if(data['vf7'+k[0].toUpperCase()+k.slice(1)])model[k]=data['vf7'+k[0].toUpperCase()+k.slice(1)];return model;};
 window.vendifoxModelSpecsV9=specs;
 const bars=()=>[...document.querySelectorAll('.vf7-compare-bar')],status=text=>bars().forEach(b=>{const s=b.querySelector('[role="status"]');if(s)s.textContent=text;});
 const update=()=>{document.querySelectorAll('.vf3-model').forEach(card=>{const m=info(card),b=card.querySelector('[data-vf7-compare]');if(!m||!b)return;const chosen=selected.some(s=>s.id===m.id);if(chosen)selected=selected.map(s=>s.id===m.id?m:s);b.setAttribute('aria-pressed',String(chosen));b.textContent=chosen?'✓ Im Vergleich':'＋ Vergleichen';b.setAttribute('aria-label',(chosen?'Aus Vergleich entfernen: ':'Zum Vergleich hinzufügen: ')+m.title);});bars().forEach(bar=>{bar.hidden=!selected.length;bar.querySelector('[data-vf7-selected]').textContent=selected.length+' / 3 Modelle ausgewählt';const open=bar.querySelector('[data-vf7-open]');if(open){open.disabled=false;open.textContent='Vergleich öffnen →';}});try{sessionStorage.setItem(key,JSON.stringify(selected));}catch{}};
 const close=dialog=>{if(typeof dialog.close==='function'&&dialog.open)dialog.close();else{dialog.removeAttribute('open');dialog.classList.remove('vf9-dialog-fallback');opener?.focus({preventScroll:true});}};
 const open=()=>{if(!selected.length){status('Wähle ein Modell aus, um den Vergleich zu starten.');return;}const dialog=document.querySelector('.vf7-compare-dialog');if(!dialog){status('Der Vergleich ist hier nicht verfügbar. Öffne die Modellübersicht.');return;}const table=dialog.querySelector('table');if(!table){status('Die Vergleichsansicht konnte nicht geladen werden. Bitte lade die Seite neu.');return;}table.replaceChildren();const thead=node('thead'),head=node('tr'),first=node('th','Merkmal');first.scope='col';head.append(first);selected.forEach(m=>{const th=node('th');th.scope='col';if(m.image){const img=node('img');img.src=m.image;img.alt=m.title;th.append(img);}th.append(node('strong',m.title));const remove=node('button','Entfernen');remove.type='button';remove.dataset.vf9Remove=m.id;remove.setAttribute('aria-label',m.title+' aus dem Vergleich entfernen');th.append(remove);head.append(th);});thead.append(head);table.append(thead);const tbody=node('tbody');for(const [label,k]of [['Sortiment','label'],['Profil','description'],['Maße laut Produkt','dimensions'],['Bedienung / Ausgabe','display'],['Kapazität laut Produkt','capacity'],['Temperaturbereich','temperature'],['Außeneinsatz','outdoor'],['Payment','payment'],['Preis','price']]){const row=node('tr'),th=node('th',label);th.scope='row';row.append(th);selected.forEach(m=>row.append(node('td',m[k]||'Details auf der Produktseite')));tbody.append(row);}const row=node('tr'),th=node('th','Produktdetails');th.scope='row';row.append(th);selected.forEach(m=>{const td=node('td'),a=node('a','Zum Produkt ↗');a.href=m.url;td.append(a);row.append(td);});tbody.append(row);table.append(tbody);dialog.querySelector('.vf7-compare-help').textContent=selected.length===1?'Dein erstes Modell ist ausgewählt. Schließe diese Ansicht und wähle ein zweites Modell für den direkten Vergleich.':'Deine Modelle im direkten Vergleich. Ausstattung und Kapazität hängen von der Konfiguration ab.';const advice=dialog.querySelector('[data-vf7-compare-advice]'),base=document.querySelector('.vf3-desktop-nav a[href*="contact"]')?.getAttribute('href')||'/pages/contact';if(advice)advice.href=base+'?projekt='+encodeURIComponent('Modellvergleich: '+selected.map(m=>m.title).join(', '));if(!dialog.open){opener=document.activeElement;if(typeof dialog.showModal==='function')dialog.showModal();else{dialog.setAttribute('open','');dialog.classList.add('vf9-dialog-fallback');dialog.querySelector('[data-vf7-close]')?.focus();}}};
 document.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.matches('[data-vf7-compare]')){const m=info(b.closest('.vf3-model'));if(!m)return;const index=selected.findIndex(s=>s.id===m.id);if(index>=0)selected.splice(index,1);else if(selected.length<3)selected.push(m);else{status('Drei Modelle ausgewählt. Entferne zuerst einen Favoriten.');return;}update();status(selected.length===1?'Ein Modell ausgewählt. Du kannst es ansehen oder ein zweites zum Vergleich hinzufügen.':'');}else if(b.matches('[data-vf7-open]'))open();else if(b.matches('[data-vf7-clear]')){selected=[];update();status('');document.querySelectorAll('.vf7-compare-dialog[open]').forEach(close);}else if(b.matches('[data-vf7-close]'))close(b.closest('.vf7-compare-dialog'));else if(b.matches('[data-vf9-remove]')){selected=selected.filter(m=>m.id!==b.dataset.vf9Remove);update();if(selected.length)open();else close(b.closest('.vf7-compare-dialog'));}});
 document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.vf9-dialog-fallback[open]').forEach(close);});
 const init=()=>{for(const selector of ['.vf7-compare-bar','.vf7-compare-dialog']){const all=[...document.querySelectorAll(selector)],keeper=all.find(n=>n.dataset.vf9Portal)||all[0];if(!keeper)continue;all.filter(n=>n!==keeper).forEach(n=>n.remove());keeper.dataset.vf9Portal='true';keeper.classList.add('vf3');if(keeper.parentElement!==document.body)document.body.append(keeper);}document.querySelectorAll('.vf7-compare-dialog').forEach(d=>{if(!d.dataset.vf9Focus){d.dataset.vf9Focus='true';d.addEventListener('close',()=>opener?.focus({preventScroll:true}));}});update();};init();document.addEventListener('shopify:section:load',init);new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-vf3-root],.vf3-model')||n.querySelector?.('.vf3-model')))))init();}).observe(document.body,{childList:true,subtree:true});
})();
